import { useAtom } from "jotai";
import { useCallback, useEffect } from "react";

import { pluralizeEntries, retrieveFromSessionStorage } from "../../utils";
import { Modal } from "../modal/modal.component";

import {
  AUTO_HIDE_INTRO_MODAL_DELAY_SECONDS,
  INTRO_MODAL_SWEEP_TOTAL_ENTRIES,
} from "./arcade-intro-modal.constants";
import { showIntroModalAtom } from "./arcade-intro-modal.state";

export function ArcadeIntroModal() {
  const [showIntroModal, setShowIntroModal] = useAtom(showIntroModalAtom);

  const lastSweepExtraEntries = retrieveFromSessionStorage(
    INTRO_MODAL_SWEEP_TOTAL_ENTRIES
  );

  const handleHideIntroModal = useCallback(() => {
    sessionStorage.removeItem(INTRO_MODAL_SWEEP_TOTAL_ENTRIES);
    setShowIntroModal(false);
  }, [setShowIntroModal]);

  useEffect(() => {
    setTimeout(() => {
      handleHideIntroModal();
    }, AUTO_HIDE_INTRO_MODAL_DELAY_SECONDS * 1000);
  }, [handleHideIntroModal]);

  return (
    <Modal isOpen={showIntroModal} className="arcade-intro__modal" delay={0}>
      <div className="arcade-intro__modal--title">
        Thank you for entering! You have earned{" "}
        <span>{lastSweepExtraEntries}</span>{" "}
        {pluralizeEntries(lastSweepExtraEntries ?? "")}.
      </div>
      <div className="arcade-intro__modal--welcome">
        <div className="welcome-label">WELCOME TO THE</div>
        <div className="grow-text">ARCADE</div>
        <p className="welcome-description">
          {"Don't want to wait to win? Enter the FindKeepLove Arcade to play " +
            "games and earn points that you can exchange for prizes!"}
        </p>
        <button
          className="arcade-intro__modal--play-gradient-btn"
          onClick={handleHideIntroModal}
        >
          Play now
        </button>
      </div>
      <div className="arcade-intro__modal--prizes">
        <img
          src={window.FKL.arcadeLandscapeImg}
          className="image-desktop"
          alt="Arcade Prizes"
        />
        <img
          src={window.FKL.arcadeSquareImg}
          className="image-mobile"
          alt="Arcade Prizes"
        />
      </div>
    </Modal>
  );
}

declare global {
  interface FKL {
    arcadeLandscapeImg: string;
    arcadeSquareImg: string;
  }
}
